module.exports = __webpack_public_path__ + "media/images/bg/tracking8-b1bfd08cbf5fc4d99c92cab7cda595ff.jpg";